function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .calendar_svg__calendar_svg__st0{fill:#484848}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    Group Copy\n  ");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "\n    Created with Sketch.\n  ");

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-830.000000, -453.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(830.000000, 453.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "calendar_svg__calendar_svg__st0",
  d: "M10.8,1.1h-0.5V0.5C10.3,0.2,10,0,9.8,0S9.2,0.2,9.2,0.5v0.5H7V0.5C7,0.2,6.8,0,6.5,0 S6,0.2,6,0.5v0.5H3.8V0.5C3.8,0.2,3.5,0,3.2,0S2.7,0.2,2.7,0.5v0.5H2.2C1,1.1,0,2.1,0,3.2v7.6C0,12,1,13,2.2,13h8.7 c1.2,0,2.2-1,2.2-2.2V3.2C13,2.1,12,1.1,10.8,1.1z M2.2,2.2h0.5v0.5C2.7,3,3,3.2,3.2,3.2S3.8,3,3.8,2.7V2.2H6v0.5 C6,3,6.2,3.2,6.5,3.2S7,3,7,2.7V2.2h2.2v0.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V2.2h0.5c0.6,0,1.1,0.5,1.1,1.1v1.1H1.1V3.2 C1.1,2.7,1.6,2.2,2.2,2.2z M10.8,11.9H2.2c-0.6,0-1.1-0.5-1.1-1.1V5.4h10.8v5.4C11.9,11.4,11.4,11.9,10.8,11.9z"
}))));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 3.5,
  cy: 7.5,
  r: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 5.5,
  cy: 7.5,
  r: 0.5
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 7.5,
  cy: 7.5,
  r: 0.5
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 9.5,
  cy: 7.5,
  r: 0.5
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 3.5,
  cy: 9.5,
  r: 0.5
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 5.5,
  cy: 9.5,
  r: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 7.5,
  cy: 9.5,
  r: 0.5
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "calendar_svg__calendar_svg__st0",
  cx: 9.5,
  cy: 9.5,
  r: 0.5
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default SvgCalendar;